export default __webpack_public_path__ + "static/media/quince.e48c94ec.svg";